<template>
  <fb-main-body>
    <div style="display: flex">
      <el-radio-group v-model="searchRadio" style="margin-right: 14px">
        <el-radio :label="1">{{$t('lang.全部')}}</el-radio>
        <el-radio :label="2">{{$t('lang.按时间范围')}}</el-radio>
        <el-date-picker
            v-model="time"
            :disabled="searchRadio != 2"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="~"
            :start-placeholder="$t('lang.开始日期')"
            :end-placeholder="$t('lang.结束日期')">
        </el-date-picker>
      </el-radio-group>

      <el-button size="mini" type="primary" icon="el-icon-search" @click.stop="handleSearch">{{$t('lang.搜索')}}</el-button>
      <el-button size="mini" type="primary" @click.stop="handleReset">{{$t('lang.重置')}}</el-button>
    </div>

    <div class="main">

      <div class="main-item" v-for="i in summarylist" :key="i.productCode">
        <div class="row">
          <span>{{$t('lang.型号')}}</span>
          <span class="row-type">{{ i.productModel }}</span>
        </div>

        <div class="row">
          <span>{{$t('lang.总报障次数')}}</span>
          <span>{{ i.count }}{{$t('lang.次')}}</span>
        </div>

        <div class="row" v-for="fault in i.faultTypeList" :key="fault.faultType + '_key'">
          <span>{{ fault.faultType + $t(`lang.${fault.faultTypeName}`) }}</span>
          <span>{{ fault.count }}{{$t('lang.次')}}（{{ filterNum(fault.count, i.count) }}%）</span>
        </div>

      </div>


    </div>

  </fb-main-body>
</template>

<script>
export default {
  name: "FaultCollectDetail",
  data() {
    return {
      api: {
        summary: this.$api.deviceFaultLog.summary,
      },
      searchRadio: 1,
      time: '',
      summarylist: [],
      searchForm: {}
    }
  },
  watch: {
    time: {
      handler(val) {
        const vm = this;
        if (val.length) {
          vm.searchForm['startTime'] = val[0];
          vm.searchForm['endTime'] = val[1];
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleSearch() {
      this.handleGetInfo();
    },
    handleReset() {
      this.searchForm = {};
      this.time = [];
    },
    handleGetInfo() {
      const vm = this;
      let item = sessionStorage.getItem('login-user-info');
      if (item) {
        let userInfo = JSON.parse(item);
        vm.searchForm.brandOwnerCode = userInfo.brandOwnerCode
      }
      vm.$http.post(vm.api.summary, this.$qs.stringify(vm.searchForm)).then(res => {
        if (res.data.status != 200) {
          vm.$message.error(res.data.desc);
          return;
        }
        vm.summarylist = res.data.data['summary'];
        console.log('data', vm.summarylist)
      });
    },
    filterNum(count, total) {
      if (total == 0) return 0;
      let num = count / total;
      return Math.round(num);
    }
  },
  created() {
    this.handleGetInfo();
  }
}
</script>

<style scoped>

.main {
  display: flex;
  flex-wrap: wrap;
}

.main-item {
  border: 1px solid #dddddd;
  padding: 22px;
  width: 340px;
  margin-right: 24px;
  margin-top: 24px;
}

.row {
  display: flex;
  justify-content: space-between;
  line-height: 45px;
}

.row-type {
  font-weight: bold;
  font-size: 22px;
}

</style>
